const FieldNumber = ({
  value = '',
  onChange,
  isEditor = false,
  className = ''
}) => {

  const handleChange = (e) => {
    let val = e.target.value;
    val = val === '' ? 0 : Math.abs(Number(val));
    onChange({
      ...e,
      target: {
        ...e.target,
        value: String(val)
      }
    });
  };

  if (!isEditor) {
    return (
      <span className={`whitespace-pre-line break-words ${isEditor ? className : 'text-gray-600'}`}>
        {value}
      </span>
    );
  }

  return (
    <input
      type="number"
      value={value}
      min={0}
      onChange={handleChange}
      className={className}    
    />
  );
};

export default FieldNumber;
